import { motion } from "framer-motion";
import { Polaroid } from "./BrandDecor";
import { RevealLines, Overline } from "./Reveal";

const WORK_1 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_valorizza-stile/artifacts/rw55p3no_WhatsApp%20Image%202026-02-13%20at%2016.03.06.jpeg";
const WORK_CLIENT = process.env.PUBLIC_URL + "/brand/photo-boutique.jpg";

const PILLARS = [
  {
    num: "01",
    title: "Consapevolezza",
    desc: "Scopri i colori, le forme e le proporzioni che ti valorizzano davvero.",
  },
  {
    num: "02",
    title: "Capsule",
    desc: "Costruisci una base versatile, funzionale e senza tempo per il tuo guardaroba.",
  },
  {
    num: "03",
    title: "Styling",
    desc: "Impara l'arte di mixare, creare e abbinare tra loro i capi del tuo armadio.",
  },
  {
    num: "04",
    title: "Integrazione",
    desc: "Ottimizza i tuoi acquisti e impara a scegliere solo pezzi davvero necessari.",
  },
];

export const ImageBand = () => {
  return (
    <section id="metodo" className="relative py-24 sm:py-32 overflow-hidden" data-testid="image-band">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative z-10">
        <Overline className="mb-8">Il Metodo</Overline>
        <h2 className="font-display uppercase text-fuchsiabrand text-4xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight max-w-4xl">
          <RevealLines
            lines={[
              "Quattro pilastri",
              <>per uno <span className="text-espresso">stile</span></>,
              <span className="text-espresso">autentico</span>,
            ]}
          />
        </h2>

        {/* Pillars */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`pillar-${p.num}`}
            >
              <div className="flex items-baseline gap-3">
                <span className="font-display text-2xl text-fuchsiabrand">{p.num}</span>
                <h3 className="font-display text-xl text-espresso">{p.title}</h3>
              </div>
              <div className="h-px w-full bg-espresso/10 my-4" />
              <p className="text-stone leading-relaxed text-[15px]">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Photos — two real-work polaroid frames */}
        <div className="mt-20 grid md:grid-cols-2 gap-10 sm:gap-12 justify-items-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-md"
            data-testid="image-band-photo-1"
          >
            <Polaroid
              src={WORK_1}
              alt="Alina Cossali seleziona i capi d'abbigliamento durante una consulenza"
              rotate={-2.5}
              className="w-full"
              imgClassName="w-full object-cover aspect-[4/3]"
            />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-md"
            data-testid="image-band-photo-2"
          >
            <Polaroid
              src={WORK_CLIENT}
              alt="Alina Cossali sceglie un capo insieme a una cliente in boutique"
              rotate={2.5}
              clip
              className="w-full"
              imgClassName="w-full object-cover aspect-[4/3]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
